/*
* @Author: abhishek714
* @Date:   2025-03-10 11:54:24
* @Last Modified by:   abhishek714
* @Last Modified time: 2025-03-24 12:00:59
*/
import React from 'react';
import {Link,Redirect} from 'react-router-dom';
import $ from 'jquery';
import uploadImageIcon from '../../images/assets/image-plus.webp';
import lockIcon from '../../images/lock-icon-img.png';
import UserService from './../../services/UserService/UserService';
import SideBar from '../../components/User/SideBar';
import { Validation } from '../../validation';
import { SITE_URL, urlPath } from '../../constants.js';
import Loader from './../../components/Loader/Loader';

class MyAccount extends React.Component{
	constructor(props){
		super(props);
		this.state ={
			fields: {},
            errors: {},
            userData: {},
            page:"",
            form_error_message:"",
            form_success_message:"",
            isLoading:0
        }
		this.userService = new UserService();
		this.handleChange = this.handleChange.bind(this);
		this.setFields = this.setFields.bind(this);
		this.renderFormError = this.renderFormError.bind(this);
		this.renderFormSuccess = this.renderFormSuccess.bind(this);
	}

	componentDidMount() {
		if (localStorage.getItem('techtop_user_id') != '' && localStorage.getItem('techtop_user_id') != null) {
			const userId = localStorage.getItem('techtop_user_id');
			this.setFields(userId);
		}
		this.setState({ page : urlPath.replace("user/","")})
	}

	setFields(user_id) {
		this.setState((prevState) => {
		    const updatedData = {
		        user_id: user_id,
		        first_name: localStorage.getItem('techtop_user_first_name'),
		        last_name: localStorage.getItem('techtop_user_last_name'),
		        company: localStorage.getItem('techtop_user_company'),
		        phone: localStorage.getItem('techtop_user_phone'),
		        company_logo: (localStorage.getItem('techtop_user_company_logo') !== 'null' &&
		                       localStorage.getItem('techtop_user_company_logo') !== null &&
		                       localStorage.getItem('techtop_user_company_logo') !== '') 
		                       ? SITE_URL + "files/company_logo/" + localStorage.getItem('techtop_user_company_logo') 
		                       : uploadImageIcon,
		        cell_phone: localStorage.getItem('techtop_user_cell_phone'),
		        direct_phone: localStorage.getItem('techtop_user_direct_phone'),
		        fax: localStorage.getItem('techtop_user_fax'),
		        address: localStorage.getItem('techtop_user_address'),
		        state: localStorage.getItem('techtop_user_state'),
		        city: localStorage.getItem('techtop_user_city'),
		        zip: localStorage.getItem('techtop_user_zip'),
		        email: localStorage.getItem('techtop_user_email'),
		        middle_initial: localStorage.getItem('techtop_user_middle_initial'),
		        associate_with: localStorage.getItem('techtop_user_associate_with')
		    };

		    return {
		        fields: { ...prevState.fields, ...updatedData },
		        userData: { ...prevState.userData, ...updatedData }
		    };
		});
	}

	handleSubmit(e) {
	    e.preventDefault();
	    const { fields } = this.state;
	    let validationFields = ['first_name', 'last_name', 'company', 'address', 'phone', 'email'];
	    let errors = Validation(fields, validationFields);
	    if (Object.keys(errors).length > 0) {
	        this.setState({ errors: errors });
	        return;
	    }
	    this.submitForm(e);
	}

	submitForm(e) {
		e.preventDefault();
		let { fields, user_id, company_logo_file } = this.state
		if (this.state.company_logo_file) {
			fields['company_logo'] = company_logo_file;
		}
		let data = fields;
		this.setState({ isLoading : 1});
		this.setState({form_error_message:''});
		this.setState({form_success_message:''});
		this.userService.updateProfile(data).then(response=> {
			this.setState({ isLoading : 0});
			if(response.status===200) {
				if(response.data.response==='fail') {
        			this.setState({form_error_message:response.data.message});
        		} else {
        			const user = response.data.result;
        			Object.entries(user).forEach(([key, value]) => {
		              localStorage.setItem(`techtop_user_${key}`, typeof value === "object" ? JSON.stringify(value) : value);
		            });
		            this.setFields(user_id);
		            this.setState({form_success_message:response.data.message});
        		}
        	}
		});
	}

	handleChange(field, e){
		let { fields, errors } = this.state; 
		const { name, value } = e.target;
		const newFormData = {
            ...fields,
            [name]: value,
        };
        errors = {
        	...errors,
        	[name]:''
        };
        this.setState({fields : newFormData, errors : errors, form_error_message : '', form_success_message: '' });
	}

	handleLogoChange(e) {
	    const file = e.target.files[0];
	    if (file) {
	        const reader = new FileReader();
	        reader.onload = (event) => {
	            this.setState((prevState) => ({
	                company_logo_file: file,
	                fields: {
	                    ...prevState.fields,
	                    company_logo: event.target.result,
	                }
	            }));
	        };
	        reader.readAsDataURL(file); // Convert image to base64 for preview
	    }
	}

	renderFormError() {
		const { form_error_message } = this.state;
		return(
			<React.Fragment>
				{(form_error_message) && 
					(
						<React.Fragment>
							<div className="alert alert-danger text-center mt-2" role="alert">
								<h4 className="alert-heading fw-bold"> Error !</h4>
								<p>{ form_error_message }</p>
							</div>
						</React.Fragment>
					)
				}
			</React.Fragment>
		)
	}

	renderFormSuccess() {
		const { form_success_message } = this.state;
		return(
			<React.Fragment>
				{(form_success_message) && 
					(
						<React.Fragment>
							<div className="alert alert-success text-center mt-2" role="alert">
								<p><h4 className="alert-heading fw-bold"> Success !</h4> { form_success_message }</p>
							</div>
						</React.Fragment>
					)
				}
			</React.Fragment>
		)
	}



	renderCompanyLogo(userData) {
		return(
			<React.Fragment>
				<div className="row">
					<div className="col-md-12">
						<div className="mb-3">
							<div className="admin-upload-logo">
								<img src={userData.company_logo} className="img-fluid d-block" alt="Upload Logo"/>
								<input type="file" id="company_logo" className="d-none" onChange={this.handleLogoChange.bind(this)} accept="image/*"/>
							</div>
							<div className="admin-upload-btn">
								<button type="button" className="upload-logo-btn" onClick={() => document.getElementById('company_logo').click()}>Upload Logo</button>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}

	renderForm(userData) {
		let { errors } = this.state;
		return(
			<React.Fragment>
				<div className="row">
					<div className="col-md-4 col-sm-4 col-lg-3 col-xl-3">
						<div className="mb-3">
							<label htmlFor="first_name" className="form-label">First Name:</label>
							<input type="text" className="form-control" name="first_name" id="first_name" onChange={this.handleChange.bind(this, "first_name")} value={userData["first_name"]}/>
							{errors.first_name && <div className="text-danger">{errors.first_name}</div>}
						</div>
					</div>
					<div className="col-md-4 col-sm-4 col-lg-3 col-xl-3">
						<div className="mb-3">
							<label htmlFor="middle_initial" className="form-label">Middle Name:</label>
							<input type="text" className="form-control" name="middle_initial" placeholder="Middle Name" id="middle_initial" ref="middle_initial" onChange={this.handleChange.bind(this, "middle_initial")} value={userData["middle_initial"]}/>
						</div>
					</div>
					<div className="col-md-4 col-sm-4 col-lg-3 col-xl-3">
						<div className="mb-3">
							<label htmlFor="last_name" className="form-label">Last Name:</label>
							<input type="text" className="form-control" name="last_name" placeholder="Last Name" ref="last_name" id="last_name" onChange={this.handleChange.bind(this, "last_name")} value={userData["last_name"]}/>
							{errors.last_name && <div className="text-danger">{errors.last_name}</div>}
						</div>
					</div>
					<div className="col-md-4 col-sm-4 col-lg-3 col-xl-3">
						<div className="mb-3">
							<label htmlFor="company" className="form-label">Company Name:</label>
							<input type="text" className="form-control" name="company" placeholder="Company" ref="company" id="company" onChange={this.handleChange.bind(this, "company")} value={userData["company"]}
							/>
							{errors.company && <div className="text-danger">{errors.company}</div>}
						</div>
					</div>
					<div className="col-md-4 col-sm-4 col-lg-3 col-xl-3">
						<div className="mb-3">
							<label htmlFor="address" className="form-label">Address:</label>
							<input type="text" className="form-control" name="address" placeholder="Address" ref="address" id="address" onChange={this.handleChange.bind(this, "address")} value={userData["address"]}/>
							{errors.address && <div className="text-danger">{errors.address}</div>}
						</div>
					</div>
					<div className="col-md-4 col-sm-4 col-lg-3 col-xl-3">
						<div className="mb-3">
							<label htmlFor="city" className="form-label">City:</label>
							<input type="text" className="form-control" name="city" placeholder="Address" ref="city" id="city" onChange={this.handleChange.bind(this, "city")} value={userData["city"]}/>
						</div>
					</div>
					<div className="col-md-4 col-sm-4 col-lg-3 col-xl-3">
						<div className="mb-3">
							<label htmlFor="state" className="form-label">State</label>
							<input type="text" className="form-control" name="state" placeholder="Address" ref="state" id="state" onChange={this.handleChange.bind(this, "state")} value={userData["state"]}/>
						</div>
					</div>
					<div className="col-md-4 col-sm-4 col-lg-3 col-xl-3">
						<div className="mb-3">
							<label htmlFor="zip" className="form-label">Zip</label>
							<input type="text" className="form-control" name="zip" placeholder="Zip" ref="zip" id="zip" onChange={this.handleChange.bind(this, "zip")} value={userData["zip"]}/>
						</div>
					</div>
					<div className="col-md-4 col-sm-4 col-lg-3 col-xl-3">
						<div className="mb-3">
							<label htmlFor="phone" className="form-label">Phone Number:</label>
							<input type="text" className="form-control" name="phone" placeholder="Phone Number" ref="phone" id="phone" onChange={this.handleChange.bind(this, "phone")} value={userData["phone"]}/>
							{errors.phone && <div className="text-danger">{errors.phone}</div>}
						</div>
					</div>
					<div className="col-md-4 col-sm-4 col-lg-3 col-xl-3">
						<div className="mb-3">
							<label htmlFor="cell_phone" className="form-label">Cell Phone Number:</label>
							<input type="text" className="form-control" name="cell_phone" placeholder="Cell Phone Number" ref="cell_phone" id="cell_phone" onChange={this.handleChange.bind(this, "cell_phone")} value={userData["cell_phone"]}/>
						</div>
					</div>
					<div className="col-md-4 col-sm-4 col-lg-3 col-xl-3">
						<div className="mb-3">
							<label htmlFor="direct_phone" className="form-label">Direct Phone Number:</label>
							<input type="text" className="form-control" name="direct_phone" placeholder="Direct Phone Number" ref="direct_phone" id="direct_phone" onChange={this.handleChange.bind(this, "direct_phone")} value={userData["direct_phone"]}/>
						</div>
					</div>
					<div className="col-md-4 col-sm-4 col-lg-3 col-xl-3">
						<div className="mb-3">
							<label htmlFor="fax" className="form-label">Fax Phone Number:</label>
							<input type="text" className="form-control" name="fax" placeholder="Fax" ref="fax" id="fax" onChange={this.handleChange.bind(this, "fax")} value={userData["fax"]}/>
						</div>
					</div>
					<div className="col-md-4 col-sm-4 col-lg-3 col-xl-3">
						<div className="mb-3">
							<label htmlFor="email" className="form-label">E-mail:</label>
							<input type="email" className="form-control" name="email" placeholder="E-mail" ref="email" id="email" onChange={this.handleChange.bind(this, "email")} value={userData["email"]}
							/>
							{errors.email && <span className="text-danger">{errors.email}</span>}
						</div>
					</div>
					
				</div>
			</React.Fragment>
		)
	}

	renderProfileForm(userData) {
		return(
			<React.Fragment>
				<div className="col-md-9">	
					<div className="form py-3">
						<form onSubmit={this.handleSubmit.bind(this)}>
							{this.renderCompanyLogo(userData)}
							{this.renderForm(userData)}	
							<div className="row">
								<div className="col-md-12">
									<div className="form-bottom-div">
										<h5><img src={lockIcon} className="img-fluid" alt=""/> Password</h5>
										<button type="submit" className="update-btn">Update</button>
									</div>	
								</div>
							</div>
						</form>		
					</div>
				</div>
			</React.Fragment>
		)
	}

	render() {
		const { userData, fields, page, isLoading } = this.state;
		return(
			<React.Fragment>
				<main className="techtop-middle-div">
					<section className="techtop-my-account-section pb-5">	
						<div className="container">
							{this.renderFormError()}
							{this.renderFormSuccess()}
							<div className="row">
								<div className="col-md-12">
									<Loader isLoading={isLoading} message="Processing..."/>
									<div className="techtop-default-title2">
										<div className="row">
											<div className="col-6">	
												<h1 className="m-0 dark-color1">My Account</h1>
											</div>
											<div className="col-6">	
												<h2 className="m-0 dark-color1 text-end">{ userData.company }</h2>
											</div>
										</div>
									</div>
									<div id="ip-my-account-form">
										<div className="row">
											<div className="col-md-3">	
												<SideBar page={page}/>
											</div>
											{this.renderProfileForm(fields)}
										</div>		
									</div>
								</div>
							</div>
						</div>
					</section>
				</main>
			</React.Fragment>
		);
	}

}

export default MyAccount;